import React, { useContext, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import { Link } from "react-router-dom";
// import * as TBToolkit from "react-bootstrap-table2-toolkit";
// const ToolkitProvider = TBToolkit.default;
// const { Search } = TBToolkit;
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { useQuery } from "@apollo/client";
import { GET_ORGANISATIONS } from "./organisations.query";
import AddOrganisation from "src/components/AddOrganisation/AddOrganisation";
import AddInbox from "src/components/AddInbox/AddInbox";
import EditOrgName from "src/components/EditOrgName/EditOrgName";
import { useMutation } from "@apollo/client";
import { UPDATE_ENABLED } from "./enabled.query";
import { DELETE_ORG } from "./deleteQuery";
import SweetAlert from "react-bootstrap-sweetalert";
import { ThemeContext } from "src/helpers/themeContext";
import DeleteModal from "src/components/deleteModal/deleteModal";
import { GET_TEAMS } from "./teamsQuery";
import AddTeam from "src/components/AddTeam/AddTeam";
import EditTeam from "src/components/EditTeam/EditTeam";

const Teams = () => {
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [addNewModal, setAddNewModal] = useState<boolean>(false);
  const [editModal, setEditModal] = useState<boolean>(false);
  const [inboxModal, setInboxModal] = useState<boolean>(false);
  const [editOrgNameModel, setEditOrgNameModel] = useState(false);

  const [orgs, setOrgs] = useState<{ [key: string]: number }>({});

  const [selectedTeam, setSelectedTeam] = useState<number>(-1);
  const [PassedUser, setPassedUser] = useState(null);

  const [dynamic_description, setdynamic_description] = useState("");
  const [success_dlg, setsuccess_dlg] = useState(false);
  const Theme = useContext(ThemeContext);
  const [deleteModal, setDeleteModal] = useState(false);
  const [teams, setTeams] = useState<{ [key: string]: number }>({});
  const [searchText, setSearchText] = useState("");

  const columns = [
    {
      dataField: "Id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "Name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "OrgName",
      text: "Org name",
      sort: true,
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent: any, user: any) => {
        const textString: String = user.Enabled
          ? "\u{1F6AB} Disable Organisation"
          : "\u{2713} Enable Organisation";

        return (
          <div
            className="d-flex justify-content-center"
            style={{ justifySelf: "flex-start" }}
          >
            <button
              className="btn btn-light btn-sm"
              onClick={() => handleEditClick(user)}
            >
              <i className="mdi mdi-pencil font-size-16 text-success  " />
            </button>
          </div>
        );
      },
    },
  ];

  const defaultSorted: any = [
    {
      dataField: "Id",
      order: "asc",
    },
  ];
  // Removed row selection checkbox column
  const pageOptions = {
    sizePerPage: 10,
    totalSize: filteredData.length,
    custom: true,
    showTotal: true,
    paginationTotalRenderer: (from: number, to: number, size: number) => {
      return (
        <span className="react-bootstrap-total">
          Showing {from} to {to} of {size} Results
        </span>
      );
    },
  };
  //const { SearchBar } = Search;

  const { data, refetch } = useQuery(GET_TEAMS, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (data && data.msgbox_Department) {
      var tmpData = data.msgbox_Department.map(function (item: {
        DepartmentId: any;
        Name: any;
        Organisation: any;
      }) {
        teams[item.Name] = item.DepartmentId;
        setTeams({ ...teams });

        return {
          Id: item.DepartmentId,
          Name: item.Name,
          OrgName: item.Organisation.Name,
        };
      });
      setTableData(tmpData);
      setFilteredData(tmpData);
    }
  }, [data]);

  //handle Enabel/Disable
  const [addEnable] = useMutation(UPDATE_ENABLED);
  const [deleteOrg] = useMutation(DELETE_ORG);

  const handleDelete = async (user: any) => {
    setDeleteModal(false);
    await deleteOrg({
      variables: {
        OrganisationId: user.Id,
        userId: localStorage.getItem("user_id"),
        time: new Date(Date.now()).toISOString(),
      },
    });
    setsuccess_dlg(true);
    setdynamic_description(
      "Item will not be available to the user now, it will be permanently deleted in 60 days"
    );
    refetch();
  };

  //handle Addrename
  const toggleRename = () => {
    setEditOrgNameModel(!editOrgNameModel);
  };

  const handleEditClick = (data: any) => {
    setSelectedTeam(data.Id);
    setEditModal(!editModal);
  };

  useEffect(() => {
    if (selectedTeam != -1) setInboxModal(!inboxModal);
  }, [selectedTeam]);

  const handleUserClicks = () => {
    setAddNewModal(!addNewModal);
  };
  const refetchData = () => {
    refetch();
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchText(searchValue);

    const filtered = tableData.filter((item: any) => {
      return (
        item.Name?.toLowerCase().includes(searchValue) ||
        item.Id?.toString().includes(searchValue) ||
        item.OrgName?.toLowerCase().includes(searchValue)
      );
    });
    setFilteredData(filtered);
  };

  return (
    <React.Fragment>
      {success_dlg ? (
        <SweetAlert
          success
          title={Theme.name}
          onConfirm={() => {
            setsuccess_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      <DeleteModal
        isOpen={deleteModal !== false}
        cancel={() => setDeleteModal(false)}
        submit={() => handleDelete(deleteModal)}
      />
      <AddTeam
        onRefetch={refetchData}
        modal={addNewModal}
        setModal={setAddNewModal}
      />
      <EditTeam
        modal={editModal}
        setModal={setEditModal}
        onRefetch={refetchData}
        teamId={selectedTeam}
      />

      <Card>
        <CardHeader>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <h4 className="card-title">All Teams</h4>
              </div>
            </Col>
            <Col md={6}>
              <div className="d-flex flex-wrap align-items-start justify-content-md-end mt-2 mt-md-0 gap-2 mb-3">
                <div>
                  <Link to="#" className="btn btn-light" onClick={refetchData}>
                    <i className="uil uil-refresh me-1"></i> Refresh
                  </Link>
                </div>

                <div>
                  <Link
                    to="#"
                    className="btn btn-light"
                    onClick={handleUserClicks}
                  >
                    <i className="uil uil-plus me-1"></i> Add New
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          <PaginationProvider pagination={paginationFactory(pageOptions)}>
            {({ paginationProps, paginationTableProps }) => (
              <React.Fragment>
                <Row className="mb-2">
                  <Col md="4">
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="position-relative">
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Search..."
                          value={searchText}
                          onChange={handleSearch}
                        />
                        <i className="bx bx-search-alt search-icon" />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <BootstrapTable
                        bordered={false}
                        striped={false}
                        defaultSorted={defaultSorted}
                        classes="table align-middle table-nowrap"
                        headerWrapperClasses="thead-dark"
                        headerClasses="table-dark"
                        {...paginationTableProps}
                        keyField="Id"
                        columns={columns}
                        data={filteredData}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Teams;
